<!-- Mersy: use shared landing-page-grid component -->
@if (defaults.componentTool === componentToolEnum.Mersy) {
  <landing-page-grid
    [items]="items"
    [showBackground]="true"
    [isClusterView]="true">
  </landing-page-grid>
}

<!-- Rulebook / Other: existing layout -->
@if (defaults.componentTool !== componentToolEnum.Mersy) {
  <div class="" style="background:none">
    <div class="rulebook-wrapper rulebook-header">
      @if (defaults.componentTool !== componentToolEnum.Undefined) {
        <div class="rulebook-container">
          <img class="top-margin" src="../../assets/border.svg" alt="Top border decoration" />
          <img class="bottom-margin" src="../../assets/border.svg" alt="Bottom border decoration" />
          <h3>RULEBOOK EDITOR</h3>
        </div>
      }
    </div>
    <div class="tab-body">
      @if (items.length < 4) {
        <div class="landingpage landingpage-nocolumns" id="landingpage-nocolumns">
          @for (component of items; track component; let index = $index) {
            <div
              class="bordered-div"
                 [ngClass]="index === 0 ? 'tke-orange' :
                                index === 1 ? 'tke-intermediate-color' : 'tke-purple' ">
              <span class="top-label">{{getDisplayTitle(component)}} </span>
              <span class="description">
                {{component.Description}}
              </span>
              @if (!isExternalLink(component.Route)) {
                <button class="button" (click)="onItemClick(component)" routerLinkActive="active" [routerLink]="getRoute(component)">Click here<mat-icon>event</mat-icon></button>
              }
              @if (isExternalLink(component.Route)) {
                <button (click)="externalRedirect(component.Route)" class="button">
                  Click here
                  <mat-icon> event</mat-icon>
                </button>
              }
            </div>
          }
        </div>
      }
      @if (items.length >= 4) {
        <div (mouseenter)="onWheel($event)" id="landingpage-columns" class="landingpage landingpage-columns" [ngStyle]="{'overflow-x' : items.length <= (numberOfColumns * 3) ? 'hidden' : 'auto'}">
          @for (column of items | orderColumns:numberOfColumns:3; track column; let i = $index) {
            <div class="column"
              [style.min-width.%]="100 / numberOfColumns">
              @for (wrapper of column ; track wrapper; let j = $index) {
                <div class="bordered-div item"
                  [ngClass]="getComponentClass(wrapper.index, wrapper.data.ClusterId) ">
                  <span class="top-label">
                    {{getDisplayTitle(wrapper.data)}}
                  </span>
                  <span class="description">{{wrapper.data.Description}}</span>
                  @if (!isExternalLink(wrapper.data.Route)) {
                    <button class="button" (click)="onItemClick(wrapper.data)" routerLinkActive="active" [routerLink]="getRoute(wrapper.data)">
                      Click here
                      <mat-icon class='sidenav-icon'> settings_application</mat-icon>
                    </button>
                  }
                  @if (isExternalLink(wrapper.data.Route)) {
                    <button (click)="externalRedirect(wrapper.data.Route)" class="button">
                      Click here
                      <mat-icon class='sidenav-icon'> settings_application</mat-icon>
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
    <div>
      <img class="tke_footer" src="../../assets/tke_footer.png" alt="TKE Footer" />
    </div>
  </div>
}
